export default __webpack_public_path__ + "8c28a23bd2aae3f34f46d7958d8e99c0.jpg";